import { PERMISSIONS } from './PermissionsSettings';
import { ScopeMode } from '../User/scope';

type RolePermissions = { [key: string]: string[] };

/**
 * Responsable de communauté (rôle client `member`, aucun Réseau administré) :
 * uniquement ce qui se fait depuis ses communautés. Pas de pages de niveau
 * client (statistiques, publications, documents, signalements, comptes), mais
 * le rapport d'animation de ses communautés.
 * Les boutons Publier / Créer un évènement de l'accueil ouvrent l'assistant,
 * dont les cibles sont déjà limitées par /me/groups/publishable.
 */
const COMMUNITY_SCOPE_PERMISSIONS: RolePermissions = {
  publish: ['create', 'edit', 'delete'],
  publicationDetails: ['view', 'delete'],
  publicationTargetting: ['group'],
  groups: ['view'],
  messaging: ['view'],
  manageAccount: ['view', 'update'],
  animationReport: ['view'],
};

/**
 * Droits Pilotage d'un utilisateur selon le type de son client, son rôle
 * d'adhésion au client et son périmètre.
 *
 * Le rôle `member` est celui que l'API donne à un utilisateur promu
 * administrateur d'un Réseau ou d'une communauté (adhésion client simple, cf.
 * MemberOfHandler::ensureCustomerMembership) : sans entrée dans la matrice,
 * il n'avait aucun droit (menu vide, « Vous ne disposez pas des droits… »).
 * Un admin de Réseau obtient les droits d'un agent, sans la gestion des
 * comptes du client ; un responsable de communauté n'a que le périmètre de
 * ses communautés. L'API limite déjà la portée des données.
 */
export const getPermissions = (
  customerType?: string,
  customerRole?: string,
  mode: ScopeMode = 'customer',
): RolePermissions | undefined => {
  if (!customerType || !customerRole) return undefined;

  const roles = PERMISSIONS[customerType];
  if (!roles) return undefined;

  if (customerRole === 'member') {
    if (mode === 'communities') return COMMUNITY_SCOPE_PERMISSIONS;
    return roles.agent ? { ...roles.agent, manageUsers: [] } : undefined;
  }

  return roles[customerRole];
};
